import React from "react";

const Payment = () => {
  return (
    <div className="custom-margin pt-5 mt-5">
      <h1 className="text-center pt-5 mt-5 pb-5 mb-5">
        Payment System Coming Soon
      </h1>
    </div>
  );
};

export default Payment;
